import React from 'react';
import Swal from "sweetalert2";
import 'animate.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18n from 'i18next';

  const getThemeColors = () => {
    try {
      const root = document.documentElement;
      const css = getComputedStyle(root);
      const primary = (localStorage.getItem('buttons_color') || css.getPropertyValue('--buttons-color') || '#5190A6').trim();
      const cancel = '#6c757d';
      const bg = (css.getPropertyValue('--swal-bg') || '#ffffff').trim();
      const titleColor = (css.getPropertyValue('--swal-title-color') || '#333333').trim();
      const textColor = (css.getPropertyValue('--swal-text-color') || '#666666').trim();
      return { primary, cancel, bg, titleColor, textColor };
    } catch (_) {
      return { primary: '#5190A6', cancel: '#6c757d', bg: '#ffffff', titleColor: '#333333', textColor: '#666666' };
    }
  };

  const swalErrorAlert = (msg) => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    Swal.fire({
      title: i18n.t("Error!"),
      text: msg,
      icon: "error",
      width: 400,
      background: bg,
      color: textColor,
      confirmButtonColor: primary,
      cancelButtonColor: cancel,
      confirmButtonText: i18n.t("OK"),
      customClass: {
        container: 'swal-high-z-index'
      },
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });
  };

  const swalSuccessAlert= (msg) => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    return new Promise(resolve => {
    Swal.fire({
      title: i18n.t("Success!"),
      text: msg,
      icon: "success",
      width: 400,
      background: bg,
      color: textColor,
      confirmButtonColor: primary,
      cancelButtonColor: cancel,
      confirmButtonText: i18n.t("OK"),
      customClass: {
        container: 'swal-high-z-index'
      },
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {
      if(result.isConfirmed) {
        resolve(true);
      }
      else {
        resolve(false);
      }
    })
  })
  };

  const swalPendingAlert = (msg) => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    Swal.fire({
      title: i18n.t("Pending!"),
      text: msg,
      icon: "info",
      width: 400,
      background: bg,
      color: textColor,
      confirmButtonColor: primary,
      cancelButtonColor: cancel,
      confirmButtonText: i18n.t("OK"),
      customClass: {
        container: 'swal-high-z-index'
      },
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });
  };

  const swalInfoAlert = (msg) => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    return new Promise(resolve => {
      Swal.fire({
        title: i18n.t("Notice"),
        text: msg,
        icon: "info", // Changed from "success" to "info"
        width: 400,
        background: bg,
        color: textColor,
        confirmButtonColor: primary,
        cancelButtonColor: cancel,
        confirmButtonText: i18n.t("OK"),
        customClass: {
          container: 'swal-high-z-index'
        },
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      }).then((result) => {
        if(result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })
    });
  };

  
  const swalConfirmGeneralAlert = (msg, buttonText) => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    return new Promise(resolve => {
      Swal.fire({
        title: i18n.t('Confirm'),
        text: msg,
        icon: "warning",
        customClass: {
          icon: 'no-border',
          container: 'swal-high-z-index'
        },
        showCancelButton: true,
        confirmButtonColor: primary,
        cancelButtonColor: cancel,
        background: bg,
        color: textColor,
        cancelButtonText: i18n.t('Cancel'),
        confirmButtonText: i18n.t(buttonText || 'Yes, Do it!')
      }).then((result) => {
        if(result.isConfirmed) {
          resolve(true);
        }
        else {
          resolve(false);
        }
      })
    })
  };

  const swalOKAlert = (msg) => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    return new Promise(resolve => {
      Swal.fire({
        title: i18n.t('Are you sure?'),
        text: msg,
        icon: "info",
        customClass: {
          icon: 'no-border',
          container: 'swal-high-z-index'
        },
        showCancelButton: true,
        confirmButtonColor: primary,
        cancelButtonColor: cancel,
        background: bg,
        color: textColor,
        confirmButtonText: i18n.t('Yes'),
        cancelButtonText: i18n.t('No')
      }).then((result) => {
        if(result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })
    })
  };
  

  const swalConfirmDeleteAlert = msg => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    return new Promise(resolve => {
      Swal.fire({
        title: i18n.t('Are you sure?'),
        text: msg,
        iconHtml: '<img src="../custom/trash.png" width=100px, height=100px>',
        customClass: {
          icon: 'no-border',
          container: 'swal-high-z-index'
        },
        showCancelButton: true,
        confirmButtonColor: primary,
        cancelButtonColor: cancel,
        background: bg,
        color: textColor,
        cancelButtonText: i18n.t('Cancel'),
        confirmButtonText: i18n.t('Yes, delete it!')
      }).then((result) => {
        if(result.isConfirmed) {
          resolve(true);
        }
        else {
          resolve(false);
        }
      })
    })
  };

  const renderPush = (title, msg, type, subtitle) => {
    const palette = {
      success: { bg: '#E6F4EA', accent: '#2E7D32', iconBg: '#C8E6C9', iconColor: '#2E7D32' },
      error:   { bg: '#FDECEC', accent: '#C62828', iconBg: '#F8D7DA', iconColor: '#C62828' },
      info:    { bg: '#E7F1FF', accent: '#1565C0', iconBg: '#D6E4FF', iconColor: '#1565C0' },
    }[type] || { bg: '#F5F5F5', accent: '#333', iconBg: '#E0E0E0', iconColor: '#333' };
    const icon = type === 'success' ? '✓' : type === 'error' ? '!' : 'i';
    return (
      <div style={{
        position:'relative',
        display:'flex',
        gap:12,
        alignItems:'center',
        background: palette.bg,
        padding:'14px 16px',
        borderRadius:16,
        boxShadow:'0 12px 32px rgba(0,0,0,0.08)'
      }}>
        {/* decorative circle like mock */}
        <div style={{ position:'absolute', left:-22, top:-22, width:76, height:76, borderRadius:38, background: palette.iconBg, opacity:0.55 }} />
        <div style={{
          minWidth:34,
          height:34,
          borderRadius:17,
          background: palette.iconBg,
          display:'flex',
          alignItems:'center',
          justifyContent:'center',
          color: palette.iconColor,
          fontWeight:700
        }}>{icon}</div>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700, fontSize:14, color: palette.accent }}>{title}</div>
          <div style={{ fontSize:12, color:'#344054' }}>{msg}</div>
          {subtitle && <div style={{ fontSize:11, color:'#6B7280', marginTop:2 }}>{subtitle}</div>}
        </div>
        <button onClick={() => toast.dismiss()} style={{
          background:'transparent',
          border:'none',
          color:'#6B7280',
          cursor:'pointer',
          fontSize:16,
          lineHeight:1
        }}>×</button>
      </div>
    );
  };

  const successToast= (msg, subtitle) => {
    toast(renderPush(i18n.t('Files uploaded successfully') || i18n.t('Success'), msg, 'success', subtitle), {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
      closeButton: false,
      icon: false,
      style: { background:'transparent', boxShadow:'none', padding:0 }
    });
  };

  const infoToast = (msg, subtitle) => {
    toast(renderPush(i18n.t('Notice'), msg, 'info', subtitle), {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3500,
      theme: 'light',
      hideProgressBar: true,
      closeButton: false,
      icon: false,
      style: { background:'transparent', boxShadow:'none', padding:0 }
    });
  };

  const errorToast = (msg, subtitle) => {
    toast(renderPush(i18n.t('Error'), msg, 'error', subtitle), {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 4000,
      theme: 'light',
      hideProgressBar: true,
      closeButton: false,
      icon: false,
      style: { background:'transparent', boxShadow:'none', padding:0 }
    });
  };


  const swalClickProceedAlert = (msg) => {
    const { primary, cancel, bg, titleColor, textColor } = getThemeColors();
    return new Promise(resolve => {
      Swal.fire({
        title: i18n.t('Success'),
        text: msg,
        icon: "success",
        customClass: {
          icon: 'no-border',
          container: 'swal-high-z-index'
        },
        showCancelButton: false,
        confirmButtonColor: primary,
        cancelButtonColor: cancel,
        background: bg,
        color: textColor,
        confirmButtonText: i18n.t("OK"),
        cancelButtonText: i18n.t('No')
      }).then((result) => {
        if(result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      })
    })
  };

  
const AlertService = {
  swalErrorAlert,
  swalSuccessAlert,
  swalConfirmGeneralAlert,
  swalConfirmDeleteAlert,
  successToast,
  infoToast,
  errorToast,
  swalOKAlert,
  swalClickProceedAlert,
  swalInfoAlert,
  swalPendingAlert
};
export default AlertService;

